import { useEffect, useState } from "react";
import {fetchWithAuth} from "../utils/fetchWithAuth";

export default function UsageBadges() {
  const [data, setData] = useState({
    mode: "-",
    daily_free_remaining: 0,
    subscription_remaining: 0,
    prepaid_remaining: 0,
    total_remaining: 0,
  });
  const [loading, setLoading] = useState(true);

  async function fetchDetail() {
    try {
      setLoading(true);
      const res = await fetchWithAuth(`/gpt-usage/detail`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      setData(json);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchDetail();
  }, []);

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-gray-300 rounded-xl shadow text-gray-800">
      <div className="flex items-center justify-between mb-2">
        <div className="text-sm text-gray-600">
          사용 모드: <span className="font-medium">{data.mode}</span>
        </div>
        <button
          onClick={fetchDetail}
          className="px-2 py-1 text-sm rounded bg-gray-100 hover:bg-gray-200"
        >
          새로고침
        </button>
      </div>

      <div className="grid grid-cols-3 gap-2">
        <Badge label="오늘 무료" value={data.daily_free_remaining} tooltip="자정에 초기화되는 일일 무료 횟수" />
        <Badge label="구독 잔여" value={data.subscription_remaining} tooltip="구독 일일 제공량 중 남은 횟수" />
        <Badge label="충전 잔여" value={data.prepaid_remaining} tooltip="충전 패키지 잔여 횟수" />
      </div>

      <div className="mt-3 text-sm text-gray-700">
        총 합계: <span className="font-semibold">{data.total_remaining}</span>
      </div>
    </div>
  );
}

function Badge({ label, value, tooltip }) {
  return (
    <div className="flex flex-col items-center rounded-lg border p-3 bg-white">
      <div className="text-xs text-gray-500" title={tooltip}>{label}</div>
      <div className="text-xl font-bold">{value}</div>
    </div>
  );
}
